<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/promotion_cond/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div class="container">
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">年度</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="sports_year_list"
                v-model="sprm.race_sports_year"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">競技</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_event_cd_obj_list"
                v-model="sprm.license_event_id"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">種別</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="rank_promotion_type_select_list"
                v-model="sprm.rank"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-3 mb-2">
            <p class="text-center py-1 fs-6">昇降格前ライセンス</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="license_cd_obj_list"
                v-model="rank_promotion_type_tmp"
                :null-option="'設定しない'"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_promotion"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- {{ promotion_cond_list }} -->
    <div
      class="w100"
      v-if="
        typeof promotion_cond_list === 'object' &&
        Object.keys(promotion_cond_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%">年度</th>
            <th style="width: 8%">昇降格種別</th>
            <th style="width: 8%">種目</th>
            <th style="width: 15%">名称</th>
            <th colspan="2" style="width: 25%">ライセンス</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in promotion_cond_list" :key="list.id">
            <td>{{ list.sports_year }}</td>
            <td>
              {{
                get_lists_label(
                  list.promotion_type,
                  rank_promotion_type_obj_list
                )
              }}
            </td>
            <td>
              {{
                get_lists_label(
                  list.license_event_id,
                  license_event_cd_obj_list
                )
              }}
            </td>
            <td>{{ list.label }}</td>
            <td>
              {{ get_lists_label(list.before_license_id, license_cd_obj_list) }}
            </td>
            <td>
              {{ get_lists_label(list.after_license_id, license_cd_obj_list) }}
            </td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
            <td>
              <bs-button
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'article'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
// import '../../assets/bootstrap/css/sc.css';
import Common from '../../../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'ArticleListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '昇降格条件一覧',
      fromParentBtn: 'データ登録',
      promotion_obj: [],
      promotion_cond_obj: [],

      license_event_cd_obj: [],
      license_cd_obj: [],
      race_type_cd_obj: [],
      race_series_cd_obj: [],
      race_class_data_obj: [],

      rank_promotion_type_obj: [],
      rank_promotion_reason_obj: [],
      rank_promotion_result_obj: [],
      sprm: {
        sports_year: '',
        promotion_type: '',
        cal_start_date: '',
        cal_end_date: '',
        race_type_id: '',
        license_event_id: '',
        series_id: '',
        license_ids_list: [],
        class_ids_list: [],
        app_status: ''
      },
      status_list: [
        {
          key: 1,
          label: '登録のみ'
        },
        {
          key: 10,
          label: '通知・表示済'
        },
        {
          key: 20,
          label: '申請済'
        },
        {
          key: 20,
          label: '承認済'
        },
        {
          key: 90,
          label: '取消'
        }
      ],
      page: 0,
      page_limit: 30,
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsPageNav,
    BsButton,
    BsMsgAlert,
    BsSelect
  },
  computed: {
    ...mapState({}),
    get_category_data: function () {
      const category_list = this.category_list
      return function (category_id) {
        return category_list.find(category => category.id == category_id)
      }
    },
    get_category_label: function () {
      const get_func = this.get_category_data
      return function (category_id) {
        if (get_func(category_id)) {
          return get_func(category_id).label
        }
        return ''
      }
    },
    promotion_list: function () {
      const lists = [...this.promotion_obj]
      return lists
    },
    promotion_cond_list: function () {
      const lists = [...this.promotion_cond_obj]
      return lists
    },
    sports_year_list: function () {
      const start = 2023
      const nowYear = Common.getNowYear()
      const maxYear = parseInt(nowYear) + 1
      const tmps = []
      for (let i = start; i <= maxYear; i++) {
        tmps.push({
          key: i,
          label: i + '年'
        })
      }
      return tmps
    },
    license_event_cd_obj_list: function () {
      return this.license_event_cd_obj
    },
    license_cd_obj_list: function () {
      return this.license_cd_obj
    },
    license_cd_obj_list_sel_filter: function () {
      if (this.sprm.license_event_id) {
        return this.license_cd_obj_list.filter(
          list => list.license_event_cd == this.sprm.license_event_id
        )
      }
      return []
    },
    race_type_cd_obj_list: function () {
      return this.race_type_cd_obj
    },
    race_series_cd_obj_list: function () {
      return this.race_series_cd_obj
    },
    race_class_data_obj_list: function () {
      return this.race_class_data_obj
    },
    rank_promotion_type_obj_list: function () {
      return this.rank_promotion_type_obj
    },
    rank_promotion_type_select_list: function () {
      // ここで設定するのは自動、申請(昇降格)の３つ
      const chks = [10, 20, 120]
      return this.rank_promotion_type_obj.filter(type =>
        chks.includes(parseInt(type.key))
      )
    },
    rank_promotion_reason_obj_list: function () {
      return this.rank_promotion_reason_obj
    },
    rank_promotion_result_obj_list: function () {
      return this.rank_promotion_result_obj
    },
    license_cd_map_short_label: function () {
      return this.license_cd_obj_list_sel_filter.map(list => {
        list.label = list.short_label
        return list
      })
    },
    license_cd_filter_category: function () {
      const license_list = this.license_cd_obj_list.filter(license_cd => {
        if (this.sprm.license_event_id == '') {
          return true
        } else if (
          this.sprm.license_event_id != '' &&
          license_cd.license_event_cd == this.sprm.license_event_id
        ) {
          return true
        }
        return false
      })
      return function (category_id) {
        return license_list.filter(
          license_cd => license_cd.license_category == category_id
        )
      }
    },
    race_class_filter_sprm: function () {
      return this.race_class_data_obj_list
        .filter(race_class => {
          if (this.sprm.license_event_id == '') {
            return true
          } else if (
            this.sprm.license_event_id != '' &&
            race_class.license_event_id == this.sprm.license_event_id
          ) {
            return true
          }
          return false
        })
        .filter(race_class => {
          if (this.sprm.race_series_id == '') {
            return true
          } else if (
            this.sprm.race_series_id != '' &&
            typeof race_class.series === 'object' &&
            race_class.series.find(
              series => series.id == this.sprm.race_series_id
            )
          ) {
            return true
          }
          return false
        })
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    await this.loadRaceTypeCdList()
    await this.loadRaceSeriesCdList()
    await this.loadRaceClassDataList()
    await this.loadConfigObj('rank_promotion_type')
    await this.loadConfigObj('rank_promotion_reason')
    await this.loadConfigObj('rank_promotion_result')
    await this.loadSearchParam()
    await this.loadPromotionCondList()
  },
  mounted: function () {
    this.alertMessage = '昇降格データです。'
  },

  methods: {
    async delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.promotion_obj.find(category => {
          return category.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'article' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            await this.loadArticleList()
          })
      }
    },
    async loadPromotionCondList() {
      // const test = true;
      // if (test) {
      //   this.promotion_cond_obj.push({
      //     id: 0,
      //     promotion_type: 20,
      //     sports_year: 2024,
      //     label: 'テスト設定',
      //     license_event_id: 4,
      //     before_license_id: 8,
      //     after_license_id: 9,
      //   });
      //   return true;
      // }
      const params = {}
      params['stat'] = [1]
      // if (this.sprm.category_id)
      //   params['category_id'] = this.sprm.category_id;
      params['pagelimit'] = this.page_limit
      if (this.page >= 0) params['p'] = this.page
      // params['pageorder'] = 'mfj_rank_promotion_data.sort';
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'promotion_cond'
      })
      await this.basicPosts_S(
        config.BASE_API_URL + '/rank_promotion_cond/lists',
        params
      )
        .then(async response => {
          console.log('loadPromotionCondList response', response)
          this.promotion_cond_obj =
            response.data && response.data.body ? response.data.body : []
          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'promotion_cond'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'promotion_cond'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.promotion_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadPromotionList() {
      this.isLoading = true;
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const params = {}
        params['stat'] = [1]
        // if (this.sprm.category_id)
        //   params['category_id'] = this.sprm.category_id;
        params['pagelimit'] = this.page_limit
        if (this.page >= 0) params['p'] = this.page
        // params['pageorder'] = 'mfj_rank_promotion_data.sort';
        // params['pageorder'] = this.page_order;
        params['pagesort'] = 'ASC'
        this.$store.dispatch('setSearchParam', {
          data: params,
          target: 'promotion'
        })
        await this.basicPosts_S(
          config.BASE_API_URL + '/rank_promotion/lists',
          params
        )
        .then(async response => {
          console.log('loadPromotionList response', response)
          this.promotion_obj =
            response.data && response.data.body ? response.data.body : []
          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'promotion'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'promotion'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.promotion_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
      } finally {
        this.isLoading = false;
      }
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_event_cd_obj', err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceSeriesCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_series_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceSeriesCdList response', response)
          this.race_series_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_series_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceClassDataList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceClassDataList response', response)
          this.race_class_data_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_class_data_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async search_promotion() {
      this.page = 0
      await this.loadPromotionList()
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'article'
      })
    },
    async pageAction(page) {
      this.page = page
      await this.loadPromotionList()
    },
    handleClick(target) {
      this.$router.push({ path: '/promotion_cond/' + target + '/' })
    },
    async copyClick(target) {
      const post_url = config.BASE_API_URL + '/promotion_cond/copy/' + target

      let result = false
      await this.basicPosts_I(post_url, {})
        .then(async response => {
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.targetid = response.data.body[0].id
            this.alertMessage = '複製しました'
            this.alertClass = 'alert-success'
            result = true
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            // this.targetid = add;
            this.alertMessage = '複製できませんでした 500'
            this.alertClass = 'alert-danger'
          } else {
            console.log('error update status 200 error')
            // this.targetid = 'add';
            this.alertMessage = '複製できませんでした。el'
            this.alertClass = 'alert-danger'
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = '複製できませんでした。CE'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) {
            await this.loadArticleList()
          }
          this.$forceUpdate()
        })

      // this.$router.push({ path: '/article/' + target + '/' })
    },
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('article') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    }
  }
}
</script>
